import { mainFeatures, ROUTES } from '../sidebar/menu-items';

export const PROPRIETOR_DEFAULT_ROUTE = ROUTES[mainFeatures.visits].path;
export const PROPRIETOR_ALLOWED_MAIN_FEATURES: readonly (keyof typeof mainFeatures)[] = [
  mainFeatures.frequentAccess,
  mainFeatures.administration,
  mainFeatures.reservations,
  mainFeatures.visits,
  mainFeatures.managementVisitsMacroBusiness,
  mainFeatures.notices
];

function buildProprietorAllowedPaths(): string[] {
  // VDS-3228: never include bare `/app` — it would allow every `/app/*` route.
  const paths: string[] = [];
  for (const key of PROPRIETOR_ALLOWED_MAIN_FEATURES) {
    // Proprietor Administracion menu = Users only (`/app/tenants`),
    // not `/app/administrative` (all units list).
    if (key === mainFeatures.administration) {
      const usersPath = ROUTES[mainFeatures.users]?.path;
      if (usersPath) paths.push(usersPath);
      continue;
    }
    const route = ROUTES[key];
    if (!route) continue;
    if (route.path) paths.push(route.path);
    if (route.submenu?.length) {
      route.submenu.forEach((sub: { path?: string }) => sub.path && paths.push(sub.path));
    }
  }
  const macroMgmt = ROUTES[mainFeatures.managementVisitsMacro]?.path;
  const businessMgmt = ROUTES[mainFeatures.managementVisitsMacroBusiness]?.path;
  if (macroMgmt) paths.push(macroMgmt);
  if (businessMgmt) paths.push(businessMgmt);
  return [...new Set(paths)];
}

/** Paths permitidos para el guard del rol propietario (derivados de ROUTES). */
export const PROPRIETOR_ALLOWED_PATHS: readonly string[] = buildProprietorAllowedPaths();

/**
 * VDS-3444: rutas hijas de un path permitido que siguen siendo de ambito edificio.
 * La allowlist trabaja por prefijo, asi que sin estas exclusiones el propietario
 * alcanza por URL la configuracion de visitas y la creacion de avisos.
 */
export const PROPRIETOR_DENIED_PATHS: readonly string[] = [
  '/app/visits/settings',
  '/app/noticesv2/addNotice',
];

function matchesPath(normalizedUrl: string, path: string): boolean {
  return normalizedUrl === path || normalizedUrl.startsWith(path + '/');
}

/** Indica si una URL esta permitida para el rol propietario. */
export function isProprietorAllowedUrl(url: string): boolean {
  const normalized = url.split('?')[0];
  if (PROPRIETOR_DENIED_PATHS.some((path) => matchesPath(normalized, path))) return false;
  return PROPRIETOR_ALLOWED_PATHS.some((path) => matchesPath(normalized, path));
}
